<template>
    <div class="auth__providers">
        <div v-if="isAuthWithGoogle && isAuthWithGoogle === 'true'">
            <oAuthWithGoogle :mode="mode" :companyID="companyID" :companyUserDocID="companyUserDocID"/>
        </div>
        <div v-if="isAuthWithGithub && isAuthWithGithub === 'true'">
            <oAuthWithGithub :mode="mode" :companyID="companyID" :companyUserDocID="companyUserDocID"/>
        </div>
        <div v-if="isAuthWithGitlab && isAuthWithGitlab === 'true'">
            <oAuthWithGitlab :mode="mode" :companyID="companyID" :companyUserDocID="companyUserDocID"/>
        </div>
    </div>
</template>

<script setup>
import { publicConfig } from "@/config/publicConfig";
import { computed, defineProps } from "vue";

defineProps({
    mode: {
        type: String,
        default: "login"
    },
    companyID: {
        type: String,
        default: null
    },
    companyUserDocID: {
        type: String,
        default: null
    }
});

const isAuthWithGoogle = computed(() => (publicConfig.auth.google.enabled ? "true" : null));
const isAuthWithGithub = computed(() => (publicConfig.auth.github.enabled ? "true" : null));
const isAuthWithGitlab = computed(() => (publicConfig.auth.gitlab.enabled ? "true" : null));
</script>

<style>
.outh-item-gap {
    gap: 20px;
}

.oauth-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid var(--border);
    border-top: 2px solid var(--ink);
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>